// extracted by mini-css-extract-plugin
export default {"unit":"areaCell-module__unit__lBAWA"};